import { APIModel } from "./api-model";

export class Offer extends APIModel {
  id: string | undefined;
  match_id: string | undefined;
  decline_code_1: number | undefined;
  decline_code_2: number | undefined;
  physician: string | undefined;
  decline_note: string | undefined;
  seq: number | undefined;
  rank: number | undefined;
  recipient_first_name: string | undefined;
  recipient_last_name: string | undefined;
  status: string | undefined;
  recipient_id: string | undefined;
  notification_date: string | undefined;
  backup_date: string | undefined;
  primary_date: string | undefined;
  decline_date: string | undefined;
  provisional_yes_date: string | undefined;
  accept_date: string | undefined;
  offer_date: string | undefined;
  primary: boolean | undefined;
  backup: boolean | undefined;
  sequence_updated_at: string | undefined;
  relevant_offer: boolean | undefined;
  evaluation_date: string | undefined;
  email_primary_date: string | undefined;
  email_backup_date: string | undefined;
  afflo_recipient_status:string | undefined;
  offer_details_page_visited_at: string | undefined;
  offer_details_page_visited: boolean | undefined;

  static fieldsToMap = {
    direct: [
      'id',
      'match_id',
      'decline_code_1',
      'decline_code_2',
      'physician',
      'decline_note',
      'seq',
      'rank',
      'recipient_first_name',
      'recipient_last_name',
      'status',
      'recipient_id',
      'notification_date',
      'backup_date',
      'primary_date',
      'decline_date',
      'provisional_yes_date',
      'accept_date',
      'offer_date',
      'primary',
      'backup',
      'sequence_updated_at',
      'relevant_offer',
      'evaluation_date',
      'email_backup_date',
      'afflo_recipient_status',
      'offer_details_page_visited_at',
      'offer_details_page_visited'
    ]
  }

  static buildFromAPI(record: any): Offer {
    const row = new Offer();
    record = record || {};

    this.mapFieldsDirectly<Offer>(Offer.fieldsToMap.direct, record, row);

    return row;
  }
}